import { Default_LatLng } from '../application/config';
import { LatLng } from 'leaflet';
import { AnyAction } from '@reduxjs/toolkit';

// Usual actions are CRUD
export const UPDATE_LOCATION = 'location/update';
export const UNSET_LOCATION = 'location/unset';

export type LocationPayload = {
	latitude: number;
	longitude: number;
	accuracy: number;
};

export type LocationReducerAction = {
	type: string;
	payload: LocationPayload;
};

export function updateLocation(location: LatLng) {
	return {
		type: UPDATE_LOCATION,
		payload: {
			latitude: location.lat,
			longitude: location.lng,
			accuracy: 0,
		} as LocationPayload,
	};
}

const initialState: LocationPayload = {
	latitude: Default_LatLng.lat,
	longitude: Default_LatLng.lng,
	accuracy: 0,
};

export default function locationReducer(
	state = initialState,
	action: AnyAction,
) {
	switch (action.type) {
		case UPDATE_LOCATION: {
			// Omit actual code
			if (
				state.latitude !== action.payload.latitude ||
				state.longitude !== action.payload.longitude
			) {
				state = {
					latitude: action.payload.latitude,
					longitude: action.payload.longitude,
					accuracy: action.payload.accuracy,
				};
				console.log('Updating State : ', state);
			}

			return state;
		}
		case UNSET_LOCATION: {
			state = {
				latitude: Default_LatLng.lat,
				longitude: Default_LatLng.lng,
				accuracy: 0,
			};
			return state;
		}
		default:
			return state;
	}
}
